var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5C21 22.0246 20.0167 19.6507 18.2664 17.9003C16.516 16.15 14.1421 15.1667 11.6667 15.1667M11.6667 15.1667C9.19135 15.1667 6.81738 16.15 5.06704 17.9003C3.3167 19.6507 2.33337 22.0246 2.33337 24.5M11.6667 15.1667C14.8884 15.1667 17.5 12.555 17.5 9.33333C17.5 6.11167 14.8884 3.5 11.6667 3.5C8.44505 3.5 5.83337 6.11167 5.83337 9.33333C5.83337 12.555 8.44505 15.1667 11.6667 15.1667ZM25.6667 23.3333C25.6667 19.4017 23.3334 15.75 21 14C21.767 13.4246 22.3803 12.6689 22.7857 11.8C23.1911 10.931 23.376 9.97555 23.3241 9.0181C23.2722 8.06065 22.985 7.13077 22.4881 6.31073C21.9912 5.4907 21.2997 4.80581 20.475 4.31667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.519e5bad2332fff26c980452c7df92a1.svg";
export { ForwardRef as ReactComponent };